import { rootWrapper } from './root-wrapper';

// We are using wrapPageElement instead of wrapRootElement
// Using wrapRootElement lead to an error where global styles were not present
// in the server-sider render.
// See this for more details: https://github.com/gatsbyjs/gatsby/issues/24341
export const wrapPageElement = rootWrapper;
